module.exports = __webpack_public_path__ + "img/20210906-1630911115228657.4f9bcea9.jpg";